export const REQUEST_CHANGES_LOADER_DATA = "REQUEST_CHANGES_LOADER_DATA";
export const REQUEST_CHANGES_NOT_NEED_UPDATE_LOADER_DATA = "REQUEST_CHANGES_NOT_NEED_UPDATE_LOADER_DATA";